import { Tabs as MantineTabs, TabsProps } from "@mantine/core";

import classes from "./Tabs.module.css";

/**
 * `pills` is the default page-level look. `underlined` is for a secondary tab row nested
 * under a pill row, where the active tab is marked by an underline instead of a filled pill.
 */
export type TabsStyleVariant = "pills" | "underlined";

interface QuiltedTabsProps extends TabsProps {
  styleVariant?: TabsStyleVariant;
}

const classNamesByVariant: Record<TabsStyleVariant, Required<TabsProps>["classNames"]> = {
  pills: {
    tab: classes.tab,
    list: classes.tabsList,
    tabLabel: classes.tabLabel,
  },
  underlined: {
    tab: classes.underlinedTab,
    list: classes.underlinedList,
    tabLabel: classes.underlinedTabLabel,
  },
};

export default function Tabs({ children, styleVariant = "pills", ...props }: QuiltedTabsProps) {
  return (
    <MantineTabs
      radius="md"
      color="gray"
      variant="pills"
      {...props}
      classNames={classNamesByVariant[styleVariant]}
    >
      {children}
    </MantineTabs>
  );
}

Tabs.List = MantineTabs.List;
Tabs.Tab = MantineTabs.Tab;
Tabs.Panel = MantineTabs.Panel;
